export default __webpack_public_path__ + "static/2-abc1a1fdd76dc6c706542dcaab54ddeb.png";